import React from 'react';

import { noop } from 'src/utils/common';
import { AlertType } from './types';

export const emptyAlert = { message: '', title: '', type: 'info' } as AlertType;

export const AlertContext = React.createContext({
  alert: emptyAlert,
  isAlertOpen: false,
  onCloseAlert: noop,
  onOpenAlert: (alert: Partial<AlertType>) => {
    console.log('alert', alert);
  },
  onOpenAlertDelayed: (alert: Partial<AlertType>, delayMs = 0) => {
    console.log('alert', alert);
    console.log('delayMs', delayMs);
  },
});
